import { render, staticRenderFns } from "./SocietyIndex.vue?vue&type=template&id=69c26c8d"
import script from "./SocietyIndex.vue?vue&type=script&lang=js"
export * from "./SocietyIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports